import { ApiError, PaginatedResponse } from '@gorila-shared-ui/components';
import { Integration, IntegrationLog } from '../types/integrations';
import { getRequest } from './api';
import { integrationLogsUrl, integrationsUrl } from './urls/integrationUrls';

export const getIntegrations = async (
  clientId: string,
  subClientId: string,
  page: number = 1,
): Promise<{ paginatedResponse?: PaginatedResponse<Integration>; error?: ApiError }> => {
  const response = await getRequest(integrationsUrl, {
    queryParams: { clientId, subClientId, page },
  });

  return {
    paginatedResponse: response?.data,
    error: response?.error,
  };
};

export const getIntegrationLogs = async (
  clientId: string,
  subClientId: string,
  integrationId: string,
): Promise<{ logs?: IntegrationLog[]; error?: ApiError }> => {
  const response = await getRequest(integrationLogsUrl(integrationId), {
    queryParams: { clientId, subClientId },
  });

  return {
    logs: response?.data,
    error: response?.error,
  };
};
